export default function resizeProfileImage(imageUrl, size) {
  return imageUrl.replace('/profile/', `/profile/${size}/`)
}
